import { ActionIcon, Box, Center, Tooltip, type ActionIconProps } from "@mantine/core";
import { createLink } from "@tanstack/react-router";
import { type PropsWithChildren, type RefObject } from "react";

import { type NavigationItem } from "@/components/Navbar/useNavigationElements";

import styles from "./NavbarIconListItem.module.css";

interface CustomNavLinkProps extends ActionIconProps, PropsWithChildren {
  ref?: RefObject<HTMLButtonElement>;
}

export const CustomNavLinkComponent = ({ ref, children, ...props }: CustomNavLinkProps) => {
  return (
    <ActionIcon
      size="lg"
      ref={ref}
      autoContrast
      classNames={{
        root: styles["icon-nav-link"],
      }}
      {...props}
    >
      {children}
    </ActionIcon>
  );
};

const CustomNavLink = createLink(CustomNavLinkComponent);

interface Props {
  navigationItem: NavigationItem;
  onClose?: () => void;
}
const NavbarIconListItem = ({ navigationItem, onClose }: Props) => {
  return (
    <Center>
      <Tooltip label={navigationItem.title} position="right" transitionProps={{ duration: 0 }}>
        <Box onClick={onClose}>
          <CustomNavLink {...navigationItem.to}>{navigationItem.icon}</CustomNavLink>
        </Box>
      </Tooltip>
    </Center>
  );
};

export default NavbarIconListItem;
